import React from 'react'
import {Space, Typography} from "antd";

const SimpleTips = ({tips, type = "secondary", fontSize = 13, split = "·"}) => {
    return (
        <Space wrap split={split}>
            {tips.filter(t => t).map(t => <Typography.Text key={t} type={type} style={{fontSize: fontSize}}>{t}</Typography.Text>)}
        </Space>
    )
}

export default SimpleTips